export function removeItem(name: string) {
  return window.localStorage.removeItem(name);
}

export function getItem(name: string, format?: null | string) {
  const item = window.localStorage.getItem(name);
  if (format === 'json') {
    return JSON.parse(item || '{}');
  }
  return item;
}

export function setItem(name: string, value: any, format?: null | string) {
  let _value = value;
  if (format === 'json') {
    _value = JSON.stringify(_value);
  }
  window.localStorage.setItem(name, _value);
  return true;
}

export function setSsoNext(url: string) {
  setItem('sso_next', url);
}

export function clearSsoNext() {
  removeItem('sso_next');
}
export function getSsoNext() {
  return getItem('sso_next');
}
